export default "__VITE_ASSET__CMgiAaNf__"